import { component } from 'picoapp';
import ClerkManager, { Config } from 'vendor/clerk';

export default component(async (node, ctx) => {
  const productOutput:HTMLElement = node.querySelector('[data-product-output]');
  const searchHits:HTMLSpanElement = node.querySelector('[data-hits]');
  const paginationButton:HTMLButtonElement = node.querySelector('[data-load-more]');
  const paginationProgress:HTMLElement = node.querySelector('[data-pagination-progress]');
  const paginationCurrentViewed:HTMLSpanElement = node.querySelector('[data-pagination-count]');
  const paginationTotalHits:HTMLSpanElement = node.querySelector('[data-pagination-total]');

  const getUrlParam = ((parameter:string) => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(parameter);
  });

  const setUrlParam = ((parameter: string, value: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(parameter, value);
    window.history.replaceState(null, null, `?${searchParams.toString()}`);
  });

  const searchQuery = getUrlParam('q') ?? '';
  const searchPage = parseInt(getUrlParam('p') ?? '1', 10);
  const defaultLimit = 24;
  let loadedProducts = 0;

  const ClerkConfig:Config = {
    api_key: window.theme.clerkApiKey,
    productsList: productOutput,
  };

  const Clerk = new ClerkManager(ClerkConfig);

  const updatePagination = (result) => {
    const progress = (loadedProducts / result.hits) * 100;
    paginationProgress.style.width = `${progress}%`;
    paginationCurrentViewed.innerText = `${loadedProducts}`;
    paginationTotalHits.innerText = `${result.hits}`;

    if (loadedProducts < result.hits) {
      paginationButton.hidden = false;
      paginationButton.disabled = false;
    } else {
      paginationButton.hidden = true;
      paginationButton.disabled = true;
    }
  };

  const search = async ({ query, limit }) => {
    await Clerk.search([
      {
        url: 'search/search',
        type: 'search-page',
        body: {
          limit,
          query,
          offset: loadedProducts,
          attributes: ['id', 'handle'],
          labels: ['search page', `search page: ${query}`],
        },
      },
    ]).then((results) => {
      const searchResults = results.find((result) => result.custom_type === 'search-page');
      searchHits.innerText = searchResults.hits.toString();
      loadedProducts += searchResults.result.length;

      Clerk.insertProductItems(searchResults.product_data).then(() => {
        Clerk.setLoadedProducts(loadedProducts);
        updatePagination(searchResults);
        ctx.emit('app:remount');
      });
    });
  };

  search({ query: searchQuery, limit: defaultLimit * searchPage });

  paginationButton.addEventListener('click', () => {
    paginationButton.disabled = true;
    search({ query: searchQuery, limit: defaultLimit });
    const currentPage = parseInt(getUrlParam('p') ?? '1', 10);
    setUrlParam('p', (currentPage + 1).toString());
  });
});
